import { useAppTheme } from '@shared-ui/theme'
import { rw } from '@shared-ui/theme/scale'
import { useEffect } from 'react'
import { Platform, type ViewStyle } from 'react-native'
import Animated, {
  cancelAnimation,
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'
import Svg, { Circle } from 'react-native-svg'
import { LOADER_ARC } from './constants'

// Дуга бежит по бледному кольцу того же радиуса — вариант для компактных статусов
const TRACK_OPACITY = 0.17

type LoaderProps = {
  size?: number
  style?: ViewStyle
  color?: string
  isWithTrack?: boolean
}

export function Loader(props: LoaderProps) {
  const rotation = useSharedValue(0)
  const theme = useAppTheme()

  // бесконечно крутим
  useEffect(() => {
    rotation.value = withRepeat(
      withTiming(LOADER_ARC.rotationDeg, {
        duration: LOADER_ARC.durationMs,
        easing: Easing.elastic(1.2),
      }),
      0,
    )
    return () => cancelAnimation(rotation)
  }, [])

  const animatedStyles = useAnimatedStyle(
    () => {
      return {
        transform: [{ rotateZ: `${rotation.get()}deg` }],
      }
    },
    Platform.OS === 'web' ? [rotation] : undefined,
  )

  const size = Math.round(rw(props.size || 100))

  return (
    <Animated.View style={[animatedStyles, { width: size, height: size }, props.style]}>
      <Svg height={size} width={size} viewBox={`0 0 ${LOADER_ARC.viewBoxSize} ${LOADER_ARC.viewBoxSize}`}>
        {props.isWithTrack && (
          <Circle
            cx="50%"
            cy="50%"
            r={String(LOADER_ARC.radius)}
            stroke={props.color || theme.COLOR_ICON_BRAND}
            strokeOpacity={TRACK_OPACITY}
            strokeWidth={LOADER_ARC.strokeWidth}
            fill="transparent"
          />
        )}

        <Circle
          cx="50%"
          cy="50%"
          r={String(LOADER_ARC.radius)}
          strokeDasharray={LOADER_ARC.dashArray}
          stroke={props.color || theme.COLOR_ICON_BRAND}
          strokeWidth={LOADER_ARC.strokeWidth}
          fill="transparent"
          strokeLinecap="round"
        />
      </Svg>
    </Animated.View>
  )
}
